import React, { useState } from "react";
import { useAuth } from "../Auth/Auth";
import { Button, Layout, Menu } from "antd";
import {
  UserOutlined,
  CopyOutlined,
  CheckOutlined,
  SelectOutlined,
  HighlightOutlined,
  QuestionOutlined,
  TeamOutlined,
  MenuOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { SubMenu } = Menu;
const { Sider } = Layout;

interface MenuInfo {
  key: string;
  keyPath: string[];
  item: React.ReactInstance;
  domEvent: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>;
}

const rootSubmenuKeys = [
  "ユーザ管理",
  "マスタ管理",
  "採点担当管理",
  "採点",
  "ルーブリック",
  "志願者管理",
  "合否判定",
];

interface Props {
  onMenuLayoutChange: (collapsed: boolean) => void;
}

export const SideMenu = ({ onMenuLayoutChange }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [openKeys, setOpenKeys] = useState([""]);
  const [collapsed, setCollapsed] = useState(false);
  const [homeButtonClass, setHomeButtonClass] = useState("go_home_button_left");
  const [homeButtonTitle, setHomeButtonTitle] = useState(
    <>
      <HomeOutlined />
      &nbsp;&nbsp; ホーム
    </>
  );
  const [selectedKey, setSelectedKey] = useState("");
  React.useEffect(() => {
    const pathname = location.pathname + "/";
    if (user.userAuthoritys != null) {
      const currentLocation = user.userAuthoritys.find(
        (_item) =>
          _item.appURL != null &&
          _item.appURL.length > 0 &&
          pathname.startsWith(_item.appURL + "/")
      );
      if (currentLocation) {
        if (!collapsed) {
          onOpenChange([currentLocation.functionGroupName]);
        }
        setSelectedKey(currentLocation.functionCode);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.userAuthoritys, location.pathname]);

  const onOpenChange = (keys: any) => {
    const latestOpenKey = keys.find((key: any) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const handleClick = (info: MenuInfo) => {
    if (user.userAuthoritys != null) {
      const currentLocation = user.userAuthoritys.find(
        (_item) =>
          _item.appURL != null &&
          _item.appURL.length > 0 &&
          _item.functionCode === info.key
      );
      if (currentLocation) {
        navigate(currentLocation.appURL);
      }
    }
  };

  const onCollapseChange = (collapsed, type) => {
    setCollapsed(collapsed);
    onMenuLayoutChange(collapsed);
    if (collapsed) {
      setHomeButtonTitle(
        <>
          <HomeOutlined />
        </>
      );
      setHomeButtonClass("go_home_button_center");
    } else {
      setHomeButtonTitle(
        <>
          <HomeOutlined />
          &nbsp;&nbsp; ホーム
        </>
      );
      setHomeButtonClass("go_home_button_left");
    }
  };
  // const getMenuGroupKey = (groupName: string) => {
  //   if (groupName === "ユーザ管理") {
  //     return "sub1";
  //   } else if (groupName === "マスタ管理") {
  //     return "sub2";
  //   } else if (groupName === "採点担当管理") {
  //     return "sub3";
  //   } else if (groupName === "採点") {
  //     return "sub3";
  //   } else if (groupName === "ルーブリック") {
  //     return "sub7";
  //   } else if (groupName === "志願者管理") {
  //     return "sub4";
  //   } else if (groupName === "合否判定") {
  //     return "sub6";
  //   } else {
  //     return "";
  //   }
  // };
  const getMenuIcon = (groupName: string) => {
    if (groupName === "ユーザ管理") {
      return <UserOutlined />;
    } else if (groupName === "マスタ管理") {
      return <CopyOutlined />;
    } else if (groupName === "採点担当管理") {
      return <SelectOutlined />;
    } else if (groupName === "採点") {
      return <HighlightOutlined />;
    } else if (groupName === "ルーブリック") {
      return <QuestionOutlined />;
    } else if (groupName === "志願者管理") {
      return <TeamOutlined />;
    } else if (groupName === "合否判定") {
      return <CheckOutlined />;
    } else {
      return <MenuOutlined />;
    }
  };
  let lastGroupName = "";
  // let groupIndex = 0;
  const subMenuGroup: any[] = [];
  let menuItemGroup: any[] = [];
  if (user.userAuthoritys != null && user.userAuthoritys.length > 0) {
    const menuItems = user.userAuthoritys.filter((i) => i.menuDispFlag === "1");
    menuItems.forEach((element, index) => {
      if (lastGroupName !== "" && element.functionGroupName !== lastGroupName) {
        subMenuGroup.push(
          <SubMenu
            key={lastGroupName}
            icon={getMenuIcon(lastGroupName)}
            title={lastGroupName}
          >
            {menuItemGroup}
          </SubMenu>
        );
        menuItemGroup = [];
      }
      lastGroupName = element.functionGroupName;
      menuItemGroup.push(
        <Menu.Item key={element.functionCode}>{element.functionName}</Menu.Item>
      );
    });
    if (menuItemGroup.length > 0) {
      subMenuGroup.push(
        <SubMenu
          key={lastGroupName}
          icon={getMenuIcon(lastGroupName)}
          title={lastGroupName}
        >
          {menuItemGroup}
        </SubMenu>
      );
    }
    menuItemGroup = [];
  }

  return (
    <Sider
      collapsible
      width={200}
      style={{
        marginTop: 45,
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        bottom: 0,
      }}
      onCollapse={onCollapseChange}
    >
      <Button
        className={homeButtonClass}
        type="link"
        onClick={() => {
          navigate("/");
          setOpenKeys([""]);
        }}
      >
        {homeButtonTitle}
      </Button>
      <Menu
        selectedKeys={[selectedKey]}
        multiple={false}
        theme="dark"
        mode="inline"
        // defaultSelectedKeys={["1"]}
        // defaultOpenKeys={["sub1"]}
        inlineIndent={5}
        onClick={handleClick}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      >
        {subMenuGroup}
      </Menu>
    </Sider>
  );
};
